import React, { useState } from "react";

export const Navigation = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const closeNavbar = () => {
    setIsCollapsed(true);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            onClick={toggleNavbar}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            LIMAT IAS
          </a>
        </div>

        <div
          className={"collapse navbar-collapse" + (isCollapsed ? "" : " in")}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll" onClick={closeNavbar}>
                Features
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll" onClick={closeNavbar}>
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll" onClick={closeNavbar}>
                Courses
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll" onClick={closeNavbar}>
                Team
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll" onClick={closeNavbar}>
                Testimonials
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll" onClick={closeNavbar}>
                Blog
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={closeNavbar}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};






// import React from "react";

// export const Navigation = (props) => {


//   return (
//     <nav id="menu" className="navbar navbar-default navbar-fixed-top">
//       <div className="container">
//         <div className="navbar-header">
//           <button
//             type="button"
//             className="navbar-toggle collapsed"
//             data-toggle="collapse"
//             data-target="#bs-example-navbar-collapse-1"
//           >
//             <span className="sr-only">Toggle navigation</span>
//             <span className="icon-bar"></span>
//             <span className="icon-bar"></span>
//             <span className="icon-bar"></span>
//           </button>
//           <a className="navbar-brand page-scroll" href="#page-top">
//             LIMAT IAS ACADEMY
//           </a>
//         </div>

//         <div
//           className="collapse navbar-collapse"
//           id="bs-example-navbar-collapse-1"
//         >
//           <ul className="nav navbar-nav navbar-right">
//             <li>
//               <a href="#features" className="page-scroll">
//                 Features
//               </a>
//             </li>
//             <li>
//               <a href="#about" className="page-scroll">
//                 About
//               </a>
//             </li>
//             <li>
//               <a href="#services" className="page-scroll">
//                 Courses
//               </a>
//             </li>
//             <li>
//               <a href="#team" className="page-scroll">
//                 Team
//               </a>
//             </li>
//             <li>
//               <a href="#testimonials" className="page-scroll">
//                 Testimonials
//               </a>
//             </li>
//             <li>
//               <a href="#portfolio" className="page-scroll">
//                 Gallery
//               </a>
//             </li>
//             <li>
//               <a href="#contact" className="page-scroll">
//                 Contact
//               </a>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };







